/**
 * Reusable Empty State placeholder
 */
export default function EmptyState({
  icon = '📋',
  title = 'No data found',
  description,
  action,
  className = '',
}) {
  return (
    <div className={`flex flex-col items-center justify-center py-16 text-center animate-fade-in ${className}`}>
      <div className="text-5xl mb-4">{icon}</div>
      <h3 className="font-semibold text-brand-dark text-[15px] mb-1">{title}</h3>
      {description && (
        <p className="text-[13px] text-slate-500 mb-4 max-w-xs">{description}</p>
      )}
      {action}
    </div>
  );
}
